import { API_BASE_URL, request, getWithQuery } from './request';

const platformNameMap = {
  wechat: '微信公众号',
  wechat_channels: '微信视频号',
  xhs: '小红书',
  douyin: '抖音',
  kuaishou: '快手',
  baijiahao: '百家号',
  zhihu: '知乎',
  bilibili: 'B站',
  toutiao: '今日头条',
};

export const searchPublishAccounts = async (searchParams = {}) => {
  const defaultParams = {
    page: 1,
    page_size: 50,
    keyword: '',
    filters: {},
    sort: { field: 'created_at', order: 'desc' },
    ...searchParams,
  };

  if (defaultParams.filters && defaultParams.filters.platforms) {
    const platforms = Array.isArray(defaultParams.filters.platforms)
      ? defaultParams.filters.platforms
      : [defaultParams.filters.platforms];
    defaultParams.filters = {
      ...defaultParams.filters,
      platforms: platforms.map((p) => platformNameMap[p] || p),
    };
  }

  return request(`${API_BASE_URL}/accounts/search`, {
    method: 'POST',
    body: JSON.stringify(defaultParams),
  });
};

export const getPublishAccountDetail = async (accountIdOrParams) => {
  const params = typeof accountIdOrParams === 'string'
    ? { account_id: accountIdOrParams }
    : (accountIdOrParams ?? {});
  return request(`${API_BASE_URL}/accounts/detail`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
};

export const createPublishAccount = async (params = {}) => request(`${API_BASE_URL}/accounts/create`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const updatePublishAccount = async (params = {}) => request(`${API_BASE_URL}/accounts/update`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const deletePublishAccounts = async (accountIdsOrParams) => {
  let params;
  if (typeof accountIdsOrParams === 'string') {
    params = { account_id: accountIdsOrParams };
  } else if (Array.isArray(accountIdsOrParams)) {
    params = { account_ids: accountIdsOrParams };
  } else {
    params = accountIdsOrParams ?? {};
  }
  return request(`${API_BASE_URL}/accounts/delete`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
};

export const xhsAccountLoginStatus = async (params = {}) => request(`${API_BASE_URL}/accounts/xhs/login/status`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const xhsAccountLoginQrcode = async (params = {}) => request(`${API_BASE_URL}/accounts/xhs/login/qrcode`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const xhsAccountPersistCookies = async (params = {}) => request(`${API_BASE_URL}/accounts/xhs/cookies/persist`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const xhsMcpEnsure = async (params = {}) => request(`${API_BASE_URL}/accounts/xhs/mcp/ensure`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const prepareAccountLogin = async (params = {}) => request(`${API_BASE_URL}/accounts/login/prepare`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const socialAccountLoginStart = async (params = {}) => request(`${API_BASE_URL}/accounts/social/login/start`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const socialAccountLoginQrcode = async (params = {}) => request(`${API_BASE_URL}/accounts/social/login/qrcode`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const socialAccountLoginStatus = async (params = {}) => request(`${API_BASE_URL}/accounts/social/login/status`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const socialAccountLoginSms = async (params = {}) => request(`${API_BASE_URL}/accounts/social/login/sms`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const socialAccountLoginFinish = async (params = {}) => request(`${API_BASE_URL}/accounts/social/login/finish`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const socialAccountLoginCancel = async (params = {}) => request(`${API_BASE_URL}/accounts/social/login/cancel`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const douyinAccountCookieCheck = async (params = {}) => request(`${API_BASE_URL}/accounts/douyin/cookies/check`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const kuaishouAccountCookieCheck = async (params = {}) => request(`${API_BASE_URL}/accounts/kuaishou/cookies/check`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const weixinChannelsAccountCookieCheck = async (params = {}) => request(`${API_BASE_URL}/accounts/weixin_channels/cookies/check`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const listAgents = async (params = {}) => getWithQuery('/agents/list', params);
export const getAgentHealthOverview = async (params = {}) => getWithQuery('/agents/health/overview', params);
export const cleanupOfflineAgents = async (params = {}) => request(`${API_BASE_URL}/agents/cleanup_offline`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const bindAgentAccount = async (params = {}) => request(`${API_BASE_URL}/agents/bind_account`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const claimAgent = async (params = {}) => request(`${API_BASE_URL}/agents/claim`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const listAgentBindings = async (params = {}) => getWithQuery('/agents/bindings/list', params);

export const upsertAgentBinding = async (params = {}) => request(`${API_BASE_URL}/agents/bindings/upsert`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const deleteAgentBinding = async (params = {}) => request(`${API_BASE_URL}/agents/bindings/delete`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const listAgentCandidates = async (params = {}) => getWithQuery('/agents/candidates', params);

export const getLatestAgentRelease = async () => request(`${API_BASE_URL}/public/agent/releases/latest`);
